import { AccountTypeTag } from '@monorepo/shared-lib';

export { AccountTypeTag };
